import { gql } from '@apollo/client';

export const CREATE_SIBLING_RELATIONSHIP = gql`
    mutation CreateSiblingRelationship($newSiblingIdentifier: String!, $siblingUserId: Int!) {
        createSiblingRelationship(newSiblingIdentifier: $newSiblingIdentifier, siblingUserId: $siblingUserId) {
            status
        }
    }
`;
